import intlTelInput from 'intl-tel-input';

const init = () => {
    document.querySelectorAll(".ns-form").forEach((nsForm) => {
        const dynamicDisplayContainers = nsForm.querySelectorAll('.form-group-dynamic-display');
        dynamicDisplayContainers.forEach((dynamicDisplayContainer) => {
            function updateContainerClass(container) {
                const hasText = container.textContent.trim().length > 0;
                if (!hasText) {
                    container.classList.add('form-group_hidden');
                } else {
                    container.classList.remove('form-group_hidden');
                }
            }
            updateContainerClass(dynamicDisplayContainer);
            const observer = new MutationObserver(() => {
                updateContainerClass(dynamicDisplayContainer);
            });
            observer.observe(dynamicDisplayContainer, {
                childList: true,
                subtree: true,
                characterData: true,
            });
        });
        const input = nsForm.querySelector("input[type='tel']");
        let iti = intlTelInput(input, {
            separateDialCode: false,
            strictMode: true,
            countryOrder: ["gb"],
            initialCountry: "gb",
            hiddenInput: (telInputName) => ({
                phone: "phone_full",
                country: "country_code"
            }),
            loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
        });
        let itiCountryContainer = nsForm.querySelector(".iti__country-container");
        updateSelectedDialCountryCode();
        input.addEventListener("countrychange", () => {
            updateSelectedDialCountryCode();
        });
        function updateSelectedDialCountryCode(){
            const itiCountryContainer = nsForm.querySelector(".iti__country-container");
            const dialCode = iti.getSelectedCountryData().dialCode;
            itiCountryContainer.style.setProperty("--iti-current-dial-code", `"(+${dialCode})"`);
            const dynamicPadding = 80 + dialCode.length*7;
            input.style.setProperty("--iti-dial-code-dynamic-padding", `${dynamicPadding}px`);
        }
        const selects = nsForm.querySelectorAll('select');
        selects.forEach((select) => {
            if(select.value === ""){
                select.classList.add('ns-form__select-placeholder');
            }
            select.addEventListener('change', () => {
                select.classList.toggle('ns-form__select-placeholder', select.value === '');
            });
        });
    });
}
window.addEventListener("DOMContentLoaded", init, false);
